import { render, staticRenderFns } from "./filter-select.vue?vue&type=template&id=3546ac2f&scoped=true&"
import script from "./filter-select.vue?vue&type=script&lang=js&"
export * from "./filter-select.vue?vue&type=script&lang=js&"
import style0 from "./filter-select.vue?vue&type=style&index=0&id=3546ac2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546ac2f",
  null
  
)

export default component.exports